

















































































































import {Vue, Component, Watch} from 'vue-property-decorator';
import {Environment} from '@/environments/environment';
import {mixins} from 'vue-class-component';
import {Util} from '@/utils';
import clockMixin from './mixins/clock';
import {getBasicDataRouter, getRuntimeRouter, getSparepartsRouter, getWorkOrderRouter,getReportsRouter} from './service/index';
import AppCenterService from "@service/app/app-center-service";
import AppChangePassword from "@components/app-change-password/app-change-password.vue";
import FingerprintJS2 from "fingerprintjs2";


@Component({
  components: {AppChangePassword}
})
export default class Login extends mixins(clockMixin) {


  /**
   * 表单对象
   *
   * @type {*}
   * @memberof Login
   */
  public form: any = {loginname: '', password: '', textcode: '', phone: '', code: ''};

  /**
   *　登录提示语
   */
  public loginTip: any = "";

  /**
   * 验证码图片
   */
  public codeimgsrc: any = ""

  /**
   * 验证码key
   */
  public codeKey: any = ""

  /**
   *　按钮可点击
   */
  public canClick: any = true;

  /**
   * 应用名称
   *
   * @type {string}
   * @memberof Login
   */
  public appTitle: string = Environment.AppTitle;
  public cop: string = Environment.Cop;

  /**
   * 值规则
   *
   * @type {*}
   * @memberof Login
   */
  public rules = {};

  /**
   * 设置值规则
   *
   * @memberof Login
   */
  public setRules() {
    this.rules = {
      loginname: [
        {required: true, message: this.$t('components.login.loginname.message'), trigger: 'change'},
      ],
      password: [
        {required: true, message: this.$t('components.login.password.message'), trigger: 'change'},
      ],
      phone: [
        {required: true, message: this.$t('components.login.phone'), trigger: 'change'},
        {
          required: true,
          validator: this.phoneValidator,
          message: this.$t('components.login.phonewrongrule'),
          trigger: 'change'
        },
      ],
      code: [
        {required: true, message: this.$t('components.login.code'), trigger: 'change'},
      ],
      textcode: [
        {required: true, message: this.$t('components.login.textcode'), trigger: 'change'},
        {
          required: true,
          validator: this.codeValidator,
          message: this.$t('components.login.codewrongrule'),
          trigger: 'change'
        },
      ]
    }
  };

  public isTestShow:any = false
  public isShow:any = false
  /**
   * 生命周期Create
   *
   * @memberof Login
   */
  public created() {
    this.setRules();
    this.getRouterInfo();
    if (window.location.host == 'csstest.jomoo.cn' || window.location.host == 'localhost:8111') {
      this.isTestShow = true
    }
    if (window.location.host == 'css.jomoo.cn') {
      this.isShow = true
    }
    console.log('windows', window)
  }

  public mounted() {
    Util.getCookie("loginname");
    this.getVerifyCodePictrue();
  }

  getRouterInfo() {
    //todo
    Promise.all([
            getBasicDataRouter(),
            getWorkOrderRouter(),
            getSparepartsRouter(),
            getRuntimeRouter(),
            getReportsRouter()
    ])
        .then((res: any) => {
          const routeInfo: any = res
          if (routeInfo && routeInfo.length > 0) {
            let allRouter: any = []
            routeInfo.forEach((info: any) => {
              const data: any = eval('(' + info.data.replace('const routes: any =', '') + ')')
              allRouter.push(...Util.lookback(Util.loopChildren(data)))
            })
            let resultRoute: any = Util.loopChildren(allRouter);
            (this.$router as any).options.routes[0].children = resultRoute
            for (let i = 0, len = resultRoute.length; i < len; i++) {
              this.$router.addRoute('appindexview', resultRoute[i])
            }
            this.$store.dispatch('dynamicrouter/commitDynamicRouterData', allRouter)
          }
        })
  }

  /**
   * 监听语言变化
   *
   * @memberof Login
   */
  @Watch('$i18n.locale')
  onLocaleChange(newval: any, val: any) {
    this.setRules();
  }

  /**
   * 登录校验机制
   */
  async detectParamOk(): Promise<Boolean> {
    const self = this;
    const validateArr = this.accountLogin ? ["loginname", "password"] : ["phone", "textcode"];
    const promises = [];
    for (let tag of validateArr) {
      promises.push(new Promise((res, rej) => {
        // @ts-ignore
        self.$refs.loginForm.validateField(tag, err => {
          err ? res(false) : res(true);
        })
      }));
    }
    const arr = await Promise.all(promises);
    return arr.every(el => el);
  }

  /**
   * 账号密码登录
   */
  public usernameLogin() {
    const loginname: any = this.form.loginname;
    const password: any = this.form.password;
    const obj = Object.create(null);
    obj.loginname = loginname;
    obj.password = password;
    // @ts-ignore
    const post: Promise<any> = this.$http.post('/runtimeapi/v7/login', obj, true);
    this.commonLoginResponseHandler(post, loginname);
  }

  /**
   * 验证码登录
   */
  public codeLogin() {
    const phone: any = this.form.phone;
    const textcode: any = this.form.textcode;
    const pm = Object.create(null);
    pm.phone = phone;
    pm.id = textcode;
    pm.success = true;
    // @ts-ignore
    const promis = this.$http.postwithheader('/runtimeapi/app/loginByPhone', pm, {appId: "1"}, null, true);
    this.commonLoginResponseHandler(promis);
  }

  /**
   * 手机号码验证 validator
   */
  public phoneValidator(rule: any, val: string, cb: any) {
    if (/^1\d{10}$/.test(val)) {
      cb();
    }
    cb(false);
  }

  /**
   * 验证码验证 validator
   */
  public codeValidator(rule: any, val: string, cb: any) {
    if (/^\d{6}$/.test(val)) {
      cb();
    }
    cb(false);
  }

  /**
   * 通用的成功响应的处理
   */
  public commonLoginResponseHandler(promis: Promise<any>, loginname?: any) {
    promis.then((response: any) => {
      if (response && response.status === 200) {
        const data = response.data;
        if (data && data.token && !data.user && loginname) {
          if(loginname[0]!=='F'){
             this.$Message.error({
              content: '您的密码已过期，请到OA修改密码。',
              duration: 5,
              closable: true
            });
            sessionStorage.setItem("changepassword", "true")
            return
          }

          this.$Modal.confirm({
            title: '密码过期',
            content: '您的密码已过期，请通过手机验证码登入系统并修改密码,是否继续?',
            onOk: () => {
              this.tabLoginMode();
              sessionStorage.setItem("changepassword", "true");
            }
          });
          return
        }
        if (loginname) {
          sessionStorage.removeItem("changepassword");
        }
        if (data && data.token) {
          sessionStorage.setItem('token', data.token);
          // Util.setCookie('sysuaa-token', data.token, 0);
          document.cookie = 'sysuaa-token' + "=" + escape(data.token) + ';path=/';
        }
        if (data && data.user) {
          localStorage.setItem('user', JSON.stringify(data.user));
          // 手机登录的用户名设置
          if (!loginname) {
            loginname = data.user.userName || "";
          }
        }
        if (data.pwdExpiredTime) {
          sessionStorage.setItem("pwdExpiredTime", data.pwdExpiredTime);
        }
        // 设置cookie,保存账号密码7天
        Util.setCookie("loginname", loginname, 7);
        this.getFingerprint();
        this.getServiceInfo();
        // 跳转首页
        const url: any = this.$route.query.redirect ? this.$route.query.redirect : '*';
        this.$router.push({path: url});
      }
    }).catch((error: any) => {
      // 登录提示
      const data = error.data;
      if (data && data.message) {
        this.loginTip = data.message;
        this.$Message.error({
          content: (this.$t('components.login.loginfailed') as string) + ' ' + data.message,
          duration: 5,
          closable: true
        });
      } else {
        this.$Message.error({
          content: (this.$t('components.login.loginfailed') as string),
          duration: 5,
          closable: true
        });
      }
    })
  }

  public getFingerprint(): void {
    setTimeout(function () {
      let options = {
        excludes: {
          language: true,
          colorDepth: true,
          deviceMemory: true,
          pixelRatio: true,
          availableScreenResolution: true,
          timezoneOffset: true,
          timezone: true,
          sessionStorage: false,
          localStorage: false,
          indexedDb: false,
          addBehavior: true,
          openDatabase: false,
          cpuClass: true,
          doNotTrack: true,
          plugins: true,
          canvas: true,
          webglVendorAndRenderer: true,
          adBlock: true,
          hasLiedLanguages: true,
          hasLiedResolution: true,
          hasLiedOs: true,
          hasLiedBrowser: true,
          touchSupport: true,
          audio: false,
          enumerateDevices: true,
          hardwareConcurrency: true,
        },
      };
      FingerprintJS2.get(options, function (components: any[]) {
        const values = components.map((component: any) => component.value); // 配置的值的数组
        const murmur = FingerprintJS2.x64hash128(values.join(''), 31); // 生成浏览器指纹
        console.log(components);
        console.log(values);
        console.log(murmur);
        sessionStorage.setItem("Fingerprint", murmur)
      })
    }, 500)
  }

  public getServiceInfo(): void {
    const post: Promise<any> = this.$http.post('/csssparepartsapi/sppurchases/getserviceprovider', {}, false);
    post.then(res => {
      if (res.status && res.status == 200) {
        localStorage.setItem("css_spare_parts_userInfo_", JSON.stringify(res.data));
      }
    }).catch(err => {
    })
  }


  /**
   * 登陆处理
   *
   * @memberof Login
   */
  async handleSubmit(): Promise<void> {

    // 清除cookie
    let leftTime = new Date();
    leftTime.setTime(leftTime.getSeconds() - 1000);
    document.cookie = "sysuaa-token=;expires=" + leftTime.toUTCString();

    if (!(await this.detectParamOk())) {
      return;
    }

    // 账号密码登录逻辑
    if (this.accountLogin) {
      this.usernameLogin();
      return;
    }

    // 手机登录逻辑
    this.codeLogin();

  }

  /**
   * 重置页面
   *
   * @memberof Login
   */
  public goReset(): void {
    if (this.accountLogin) {
      this.form.loginname = '';
      this.form.password = '';
    } else {
      this.form.phone = '';
      this.form.textcode = '';
    }
  }

  /**
   * qq授权登录
   * @param thirdpart
   */
  public tencentHandleClick(thirdpart: any) {
    this.$Message.warning((this.$t('components.login.warning1') as string))
  }

  /**
   * 微信授权登录
   * @param thirddpart
   */
  public wechatHandleClick(thirddpart: any) {
    this.$Message.warning((this.$t('components.login.warning2') as string))
  }

  public accountLogin = true
  public loginword = this.$t('components.login.codelogin')

  /**
   * 切换登录模式
   */
  public tabLoginMode(): void {
    this.accountLogin = !this.accountLogin;
    this.loginword = !this.accountLogin ? this.$t('components.login.accountlogin') : this.$t('components.login.codelogin');
  }

  /**
   * Methods方法
   */
  public getVerifyCodePictrue() {
    const post: Promise<any> = this.$http.get('/runtimeapi/oauth/captcha', false);
    post.then(res => {
      this.codeimgsrc = res.data.image;
      this.codeKey = res.data.key;
    }).catch(err => {
      console.log(err);
    })
  }

}
